"use strict";
/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
Object.defineProperty(exports, "__esModule", { value: true });
exports.XIcon20Regular = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var forwardRef_1 = require("../../helpers/forwardRef");
var BaseIcon_1 = require("../../internal/BaseIcon");
exports.XIcon20Regular = forwardRef_1.forwardRef('XIcon20Regular', function (props, ref) {
    return (react_1.default.createElement(BaseIcon_1.BaseIcon, tslib_1.__assign({ ref: ref, viewBoxSize: 20 }, props),
        react_1.default.createElement("path", { d: "M3.981 3.981a.75.75 0 0 1 1.061 0L10 8.94l4.958-4.958a.75.75 0 0 1 1.06 1.061L11.062 10l4.958 4.958a.75.75 0 0 1-1.06 1.06L10 11.062l-4.958 4.958a.75.75 0 1 1-1.06-1.06L8.938 10 3.981 5.042a.75.75 0 0 1 0-1.06Z" })));
});
